<template>
  <WdsTabs initial-active-tab-key="pending-bills">
    <WdsTab :title="$t('Pending bills')" tab-key="pending-bills">
      <RecruiterBillsTab
        :preferred-rate-type="preferredRateType"
        :bills="pendingBills"
        :no-results-text="$t('You do not have any placements with pending bills.')"
        :description-text="
          $t(
            'This section shows pending bills that have been created by your placements. The bill status indicates that those bills are either awaiting to be approved by the client or have been approved but are now awaiting payment from the client.',
          )
        "
      />
    </WdsTab>
    <WdsTab :title="$t('Completed bills')" tab-key="completed-bills">
      <RecruiterBillsTab
        :bills="completedBills"
        :preferred-rate-type="preferredRateType"
        :no-results-text="$t('You do not have any placements with completed bills yet.')"
      >
        <template #footer>
          <small class="c-gray">
            {{
              $t('This list does not include credit notes or other irregular financial statements.')
            }}
            <br />
            {{ $t('Let us know if you need additional statements for your accounting.') }}
          </small>
        </template>
      </RecruiterBillsTab>
    </WdsTab>
  </WdsTabs>
</template>

<script setup>
import { WdsTabs, WdsTab } from '@worksome/wds-components'
import { defineProps } from 'vue'
import RecruiterBillsTab from '@/components/RecruiterBills/RecruiterBillsTab.vue'

const props = defineProps({
  pendingBills: {
    type: Array,
    default: () => [],
  },
  completedBills: {
    type: Array,
    default: () => [],
  },
  preferredRateType: {
    type: String,
    required: true,
  },
})
</script>
